import clsx from 'clsx';

import { Card, CardContent, Icon, Typography } from '@/ui';

import type { CoachProfile } from '@/types';
import type { FC } from 'react';

interface CalCardProps {
  className?: string;
  schedulingProvider?: CoachProfile['schedulingProvider'];
  username?: string;
}

const CAL_URL = import.meta.env.VITE_CAL_URL;

const CalCard: FC<CalCardProps> = ({
  username = '',
  className = '',
  schedulingProvider,
}) => {
  // MEN-5418: Moments coaches never get a Cal username, so they are set up, not missing.
  const usesMoments = schedulingProvider === 'moments';
  const hasCalLink = !usesMoments && !!username;
  const isSetUp = usesMoments || !!username;
  let title = 'Scheduling not setup';
  if (hasCalLink) title = `${CAL_URL}/${username}`;
  if (usesMoments) title = 'Moments';

  return (
    <Card
      className={clsx(
        'w-full',
        {
          'bg-poppy-200 text-poppy-600': !isSetUp,
          'bg-sage-200 text-sage-600': isSetUp,
        },
        className,
      )}
      elevation={0}
    >
      <CardContent className="flex items-center justify-between px-3 py-2">
        <div className="flex gap-2">
          <Icon>public</Icon>
          <Typography variant="body2">{title}</Typography>
        </div>
        {hasCalLink && (
          <Typography variant="body2">
            <a
              className="flex items-center"
              href={`${CAL_URL}/${username}`}
              rel="noreferrer"
              target="_blank"
            >
              <Icon>open_in_new</Icon>
            </a>
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CalCard;
